var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("div", { staticClass: "vx-card" }, [
        _c("div", { staticClass: "vx-card__header row" }, [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("h4", { staticClass: "text-primary" }, [_vm._v("Roles")])
          ])
        ]),
        _c(
          "div",
          {
            staticClass:
              "vx-card__collapsible-content vs-con-loading__container"
          },
          [
            _c(
              "div",
              { staticClass: "vx-card__body" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-3" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filtros.app,
                            expression: "filtros.app"
                          }
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.filtros,
                                "app",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function($event) {
                              return _vm.applyFilters()
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Todos")
                        ]),
                        _vm._l(_vm.applications, function(ref) {
                          var id = ref.id
                          var title = ref.title
                          return _c("option", { domProps: { value: id } }, [
                            _vm._v(" " + _vm._s(title) + " ")
                          ])
                        })
                      ],
                      2
                    )
                  ]),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filtros.permiso,
                          expression: "filtros.permiso"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { placeholder: "Busque permiso" },
                      domProps: { value: _vm.filtros.permiso },
                      on: {
                        change: function($event) {
                          return _vm.applyFilters()
                        },
                        enter: function($event) {
                          return _vm.applyFilters()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.filtros, "permiso", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "col-12 col-md-5" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filtros.nombre,
                          expression: "filtros.nombre"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { placeholder: "Busque un rol" },
                      domProps: { value: _vm.filtros.nombre },
                      on: {
                        change: function($event) {
                          return _vm.applyFilters()
                        },
                        enter: function($event) {
                          return _vm.applyFilters()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.filtros, "nombre", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "col-12 col-md-2" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Agregar rol",
                            expression: "'Agregar rol'"
                          },
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "WAR100",
                            expression: "'WAR100'"
                          }
                        ],
                        staticClass: "btn btn-primary",
                        attrs: { "data-cy": "add-rol" },
                        on: {
                          click: function($event) {
                            return _vm.addNNewRol()
                          }
                        }
                      },
                      [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                      1
                    ),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Descargar CSV",
                            expression: "'Descargar CSV'"
                          },
                          {
                            name: "has-permission",
                            rawName: "v-has-permission",
                            value: "WAR106",
                            expression: "'WAR106'"
                          }
                        ],
                        staticClass: "btn btn-secondary ml-10",
                        attrs: { "data-cy": "download-rol" },
                        on: {
                          click: function($event) {
                            return _vm.downloadReport()
                          }
                        }
                      },
                      [_c("feather-icon", { attrs: { icon: "DownloadIcon" } })],
                      1
                    )
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "ul",
                      { staticClass: "list-group mt-5" },
                      _vm._l(_vm.roles, function(role) {
                        return _c(
                          "li",
                          {
                            key: "role-" + role.rolId,
                            staticClass: "list-group-item ",
                            attrs: { id: "role-" + role.rolId }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "actions cursor-pointer" },
                              [
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Editar rol",
                                      expression: "'Editar rol'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "WAR101",
                                      expression: "'WAR101'"
                                    }
                                  ],
                                  staticClass: "icon",
                                  attrs: {
                                    size: "18",
                                    icon: "EditIcon",
                                    color: "green",
                                    "data-cy": "edit-rol-info"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editRol(role)
                                    }
                                  }
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Editar Permisos",
                                      expression: "'Editar Permisos'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "WAR103",
                                      expression: "'WAR103'"
                                    }
                                  ],
                                  staticClass: "icon",
                                  attrs: {
                                    size: "18",
                                    icon: "KeyIcon",
                                    "data-cy": "get-rol-info"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editRolPermission(role)
                                    }
                                  }
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Migrar rol",
                                      expression: "'Migrar rol'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "FEB99",
                                      expression: "'FEB99'"
                                    }
                                  ],
                                  staticClass: "icon",
                                  attrs: {
                                    size: "18",
                                    icon: "SendIcon",
                                    "data-cy": "migrate-rol"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.migrateRol(role)
                                    }
                                  }
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Eliminar rol",
                                      expression: "'Eliminar rol'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "WAR102",
                                      expression: "'WAR102'"
                                    }
                                  ],
                                  staticClass: "icon",
                                  attrs: {
                                    size: "18",
                                    icon: "DeleteIcon",
                                    color: "red",
                                    "data-cy": "delete-rol"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteRol(role)
                                    }
                                  }
                                }),
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Copiar rol",
                                      expression: "'Copiar rol'"
                                    },
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "FEB99",
                                      expression: "'FEB99'"
                                    }
                                  ],
                                  staticClass: "icon",
                                  attrs: {
                                    size: "18",
                                    icon: "CopyIcon",
                                    color: "primary",
                                    "data-cy": "copy-rol"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.copyRol(role)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-8 col-12" }, [
                                _c("b", [_vm._v("Nombre: ")]),
                                _vm._v(" " + _vm._s(role.nombre) + " ")
                              ]),
                              _c("div", { staticClass: "col-md-3 col-12" }, [
                                _c("b", [_vm._v("APP: ")]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge",
                                    style: {
                                      backgroundColor: _vm.applicationColor(
                                        role.app
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.applicationName(role.app)) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-md-8 col-12 mt-2" },
                                [
                                  _c("div", { staticClass: "about pr-3" }, [
                                    _c("b", [_vm._v("Descripción: ")]),
                                    _vm._v(" " + _vm._s(role.descripcion) + " ")
                                  ])
                                ]
                              ),
                              _c("div", { staticClass: "col-md-3 col-12" }, [
                                _c("b", [_vm._v("Ámbito: ")]),
                                _vm._v(" " + _vm._s(role.ambito) + " ")
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]),
                _c("pagination", {
                  attrs: { value: _vm.page, pages: _vm.totalPages },
                  on: { input: _vm.pageChanged }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("rol-modal", {
        ref: "rolModal",
        on: {
          saveRol: function($event) {
            return _vm.listRoles()
          }
        }
      }),
      _c("rol-copy-modal", {
        ref: "rolCopyModal",
        on: {
          saveRol: function($event) {
            return _vm.listRoles()
          }
        }
      }),
      _c("rol-delete-modal", {
        ref: "rolDeleteModal",
        on: {
          deleteRol: function($event) {
            return _vm.listRoles()
          }
        }
      }),
      _c("rol-permission-modal", { ref: "rolPermissionModal" }),
      _c("rol-migration-modal", { ref: "rolMigrationModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }